import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import LinkTable from '@/creditflowresearch/ui/common/components/LinkTable';
import {
  ICorporateTopCompany,
  ITopCompaniesCorporateResponse,
} from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/interfaces';
import {
  getTopCompanyColumns,
  topCompaniesTablesCommonProps,
} from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesTables/common/tableConfigs';
import { useRouter } from 'next/router';
import { buildQueryParams } from '@/creditflowresearch/application/helpers/buildQueryParams';
import { PARENT_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';

interface ICorporateTableProps {
  data: ITopCompaniesCorporateResponse,
  loading: boolean,
  companyRole: string,
  emptyMessageText: string,
  page: number,
  paginate: (page: number) => void,
}

const CorporateTable = ({
  data,
  loading,
  companyRole,
  emptyMessageText,
  page,
  paginate,
}: ICorporateTableProps) => {
  const { query } = useRouter();
  const queryString = buildQueryParams(query);
  const getRoutePath = companyRole === PARENT_NAME
    ? (item: ICorporateTopCompany) => item.url
    : (item: ICorporateTopCompany) => `${ item.url }?${ queryString }`;

  return (
    <>
      { loading && <Spinner isVisible overlay /> }
      <LinkTable
        { ...topCompaniesTablesCommonProps }
        columns={ getTopCompanyColumns({
          showVolume: data?.showVolume || false,
          companyRole,
        }) }
        data={ data?.collection || [] }
        perPage={ 9 }
        page={ page }
        onPageChange={ ({ selected }) => paginate(selected) }
        totalCount={ data?.totalCount || 0 }
        getRoutePath={ getRoutePath }
        isFetching={ loading }
        emptyMessageText={ emptyMessageText }
      />
    </>
  );
};

export default CorporateTable;
